import { withActivityCore } from '../withActivity';
import { DemoActivityQuery } from './queries';

export default withActivityCore(DemoActivityQuery, 'demoActivity');



// WEBPACK FOOTER //
// ./src/client/components/Strava/Demo/withDemoActivity.tsx